import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { OrderItemAdminDto } from '@/backend/market'
import { ItemMiniEntity } from '../../domain/entities/ItemMiniEntity'

export class MarketItemModel extends ItemMiniEntity {
  constructor(dataDto: OrderItemAdminDto) {
    super()
    mapEntityProperties<ItemMiniEntity>(this, dataDto, {
      map: {
        imageUrl: dataDto.item?.imageUrl,
        name: dataDto.item?.name,
        unitPrice: dataDto.unitPrice,
        itemId: dataDto.item?.id,
        description: dataDto.item?.description
      }
    })
  }
}
